// extracted by css-extract-rspack-plugin
export default {"cls1":"Cta-cls1_-py","cls2":"Cta-cls2_24P Cta-cls1_-py"};